import React, { useCallback, useState } from 'react';
import { ContinueButton } from '../../components/ContinueButton';
import { useRsi } from '../../hooks/useRsi';
import { Box, Grid, FormLabel, styled, Typography } from '@beeline.com/bp-design-system';
import { Radio, RadioGroup } from '@beeline.com/bp-design-system';
import { ModalBody } from '../../components/ModalBody';

type SelectSheetProps = {
  sheetNames: string[];
  onContinue: (sheetName: string) => Promise<void>;
  onBack?: () => void;
};

export const SelectSheetStep = ({ sheetNames, onContinue, onBack }: SelectSheetProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { translations } = useRsi();
  const [value, setValue] = useState<string | undefined>(sheetNames[0]);

  const handleOnContinue = useCallback(
    async (data: typeof value) => {
      setIsLoading(true);
      await onContinue(data as string);
      setIsLoading(false);
    },
    [onContinue]
  );

  return (
    <>
      <div>
        <Typography variant="h2" pb={2}>
          {translations.uploadStep.selectSheet.title}
        </Typography>
        <Typography pb={5}>{translations.uploadStep.selectSheet.subTitle}</Typography>
      </div>
      <ModalBody alignItems="center" constrainBox justifyContent="center">
        <RadioGroup
          onChange={(event) => {
            setValue(event.target.value);
          }}
          value={value}
        >
          <Grid spacing={3} container direction="column">
            {sheetNames.map((sheetName) => (
              <Box display="flex" alignItems="center" key={sheetName}>
                <Radio value={sheetName} id={sheetName} />
                <StyledLabel htmlFor={sheetName}>{sheetName}</StyledLabel>
              </Box>
            ))}
          </Grid>
        </RadioGroup>
      </ModalBody>
      <ContinueButton
        isLoading={isLoading}
        onContinue={() => handleOnContinue(value)}
        onBack={onBack}
        title={translations.uploadStep.selectSheet.nextButtonTitle}
        backTitle={translations.uploadStep.selectSheet.backButtonTitle}
        trackStepName="Select the sheet to use"
      />
    </>
  );
};

const StyledLabel = styled(FormLabel)`
    cursor: pointer;
`;
